<template>
    <settings-wrapper title="User settings" section="Dropbox sync">
        <v-card :loading="fetchingDropboxState">
            <v-card-subtitle>
                <a href="https://docs.nuvolos.com/reference/file-system-and-storage/mount-dropbox" target="_blank" style="text-decoration: none">
                    How does this work?
                </a>
            </v-card-subtitle>
            <v-card-text>
                <div v-if="fetchingDropboxState">
                    <p>Checking your Dropbox configuration, please wait...</p>
                </div>
                <div v-else-if="!isDropboxLinked">
                    <img src="@/assets/Dropbox.svg" width="100" class="mb-2" />
                    <p>To enable integration in Nuvolos, give access to the nuvolos.cloud application:</p>
                    <v-btn :href="redirectURI" color="primary" text>Enable access</v-btn>
                </div>
                <v-alert type="success" v-else class="mt-4" prominent text>
                    <v-row align="center">
                        <v-col class="grow">You have enabled access to your Dropbox account for nuvolos.cloud.</v-col>
                        <v-col class="shrink">
                            <v-btn text @click="unlinkDropbox()" class="ml-2">Unlink</v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
            </v-card-text>
        </v-card>
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import { dropboxEnums } from '@/mixins/dropbox.js'
import SettingsWrapper from '@/components/SettingsWrapper.vue'
import { createBackendErrorHandler } from '@/utils/errorMessages'
import * as filesStorageErrors from '@/modules/files/errors'
import * as permissionsErrors from '@/utils/errors/permissions'
import * as userErrors from '@/modules/user/errors/settings'

const { getBackendErrorMessage } = createBackendErrorHandler(filesStorageErrors, permissionsErrors, userErrors)

export default {
    name: 'UserSettingsDropboxSync',
    mixins: [dropboxEnums],
    components: {
        SettingsWrapper
    },
    mounted() {
        this.checkDropboxStatus()
    },
    methods: {
        unlinkDropbox() {
            this.$axios
                .delete('/tokens/dropbox')
                .then(() => {
                    this.$router.push({ query: {} })
                    this.$store.dispatch('showSnackBar', { snackBarText: 'Dropbox unlinked!', snackBarIcon: 'check_circle' })
                    this.checkDropboxStatus()
                })
                .catch(e => {
                    const snackBarText = getBackendErrorMessage(e, 'An error has occured, please try again later.')
                    if (snackBarText) {
                        this.$store.dispatch('showSnackBar', { snackBarText, snackBarIcon: 'error' })
                    }
                })
        }
    },
    computed: {
        ...mapState(['userMetadata']),
        dropboxMount() {
            return this.userMetadata?.use_dropbox_mount
        }
    },
    watch: {
        dropboxMount() {
            if (this.dropboxMount) {
                this.$store.dispatch('showSnackBar', {
                    snackBarText: `Successfully enrolled in new Dropbox integration.`,
                    snackBarTimeout: 5000,
                    snackBarIcon: 'check_circle'
                })
            }
        }
    }
}
</script>
